
import { forwardRef, useImperativeHandle } from "react";
import { SocialButtonProps } from "../../type";
import { guestLogin } from "../../core/auth";
import { showError } from "../../core/utils";
import { RiUserShared2Fill } from "react-icons/ri";

export interface QuickLoginButtonRef {
  triggerLogin: () => Promise<void>;
}

const QuickLoginButton = forwardRef<QuickLoginButtonRef, SocialButtonProps & { productId?: string }>(({ onSuccess, onError, apiEndpoint, productId }, ref) => {
  const handleQuickLogin = async () => {
    try {
      const data = await guestLogin(apiEndpoint, productId);
      onSuccess(data);
    } catch (e: any) {
      showError(e?.response?.data || e)
      onError(e?.response?.data || e);
    }
  };

  useImperativeHandle(ref, () => ({
    triggerLogin: handleQuickLogin
  }));

  return <button onClick={handleQuickLogin} className="quick_btn">
    <RiUserShared2Fill />
  </button>
});

QuickLoginButton.displayName = 'QuickLoginButton';

export default QuickLoginButton;